export default __webpack_public_path__ + "static/media/Calendar icon.e80cd9aa.svg";